import axios from 'axios';
import { API_HOST } from '../consts';

export const fetchCurriculumEquivalences = async (params) => {
  const res = await axios.get(
    `${API_HOST}/curricula/equivalent_grid_disciplines`,
    {
      params,
    }
  );
  return res.data;
};
export const fetchCurriculumEquivalence = async (id, params) => {
  const res = await axios.get(
    `${API_HOST}/curricula/equivalent_grid_disciplines/${id}`,
    {
      params,
    }
  );
  return res.data;
};

export const createCurriculumEquivalence = async (data) => {
  const res = await axios.post(
    `${API_HOST}/curricula/equivalent_grid_disciplines`,
    data
  );
  return res.data;
};
export const updateCurriculumEquivalence = async (id, data) => {
  const res = await axios.patch(
    `${API_HOST}/curricula/equivalent_grid_disciplines/${id}`,
    data
  );
  return res.data;
};
export const deleteCurriculumEquivalence = async (id) => {
  const res = await axios.delete(
    `${API_HOST}/curricula/equivalent_grid_disciplines/${id}`
  );
  return res.data;
};
